import { executeAPI } from "repositories/db-repository"
// helpers/transaction-helper.js
export async function insertPurchaseOrder(payload, createdBy, onSuccess, onError) {
  try {
    const base = (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
    const res = await fetch(`${base}/purchase-orders`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, createdBy: createdBy })
    })

    const json = await res.json().catch(() => ({}))

    if (!res.ok) {
      onError?.(json?.message || "Request gagal")
      return
    }

    onSuccess?.(json, json?.message)
  } catch (e) {
    onError?.(e?.message || "Network error")
  }
}

// helpers/transaction-helper.js
export async function insertPurchaseReturnFromReceipt(receiptId, payload, userName, onSuccess, onError) {
  try {
    const base = (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
    const url = `${base}/goods-receipts/${receiptId}/purchase-returns`

    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload ? JSON.stringify(payload) : null,
    })

    const json = await res.json().catch(() => ({}))
    if (!res.ok) throw new Error(json?.message || "Request gagal")

    onSuccess?.(json?.data || json, json?.message)
  } catch (e) {
    onError?.(e?.message || "Request gagal")
  }
}